'use client'

import { useEffect, useCallback } from 'react'

export function useServiceWorker(
  serviceWorkerPath: string = '/sw.js',
  {
    scope = '/',
    updateViaCache = 'none',
  }: { scope?: string; updateViaCache?: ServiceWorkerUpdateViaCache } = {}
) {
  const register = useCallback(async () => {
    if ('serviceWorker' in navigator) {
      try {
        const registration = await navigator.serviceWorker.register(serviceWorkerPath, {
          scope,
          updateViaCache,
        })

        return registration
      } catch {
        // environment does not support this
        return null
      }
    } else {
      // service worker not supported
      return null
    }
  }, [serviceWorkerPath])

  const registerOnMount = useCallback(() => {
    register()
  }, [register])

  useEffect(() => {
    registerOnMount()
  }, [registerOnMount])

  return {
    register,
  }
}

interface ServiceWorkerProviderProps {
  serviceWorkerPath: string
}

export function ServiceWorkerProvider({ serviceWorkerPath }: ServiceWorkerProviderProps) {
  useServiceWorker(serviceWorkerPath)
  return null
}
